var _circle, _text, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 80,
    fill: "none",
    stroke: "#184d18",
    strokeWidth: 8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 110,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#000000"
  }, "ranko")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(160, 105) rotate(20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C5,-20 15,-30 20,-40 C15,-10 5,-5 0,0 Z",
    fill: "#a6ed44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C10,-10 20,-15 25,-18 C15,0 5,2 0,0 Z",
    fill: "#a6ed44"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankoLogo);
export default __webpack_public_path__ + "static/media/ranko-logo.83284c0ebff0ffa6f55e5a6403c546b6.svg";
export { ForwardRef as ReactComponent };